import React from "react";
import { useState } from "react";
import Http from "../../../../Common/Http";
import { Link } from "react-router-dom";


const SalaryAdvance = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedAdvanceId, setSelectedAdvanceId] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalData, setModalData] = useState([]);
  // Fetch salary advance paid logs for modal
  const fetchAdvancePaidLogs = async (advanceId) => {
    setModalLoading(true);
    try {
      const res = await Http.get(`/hr-salary-advance-paid-logs/${advanceId}`);
      setModalData(res.data);
    } catch (error) {
      console.error("Modal fetch error:", error);
    } finally {
      setModalLoading(false);
    }
  };
  const getMonthName = (monthNumber) => {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months[parseInt(monthNumber) - 1] || monthNumber;
  };

  const handleDetailsClick = (advanceId) => {
    setSelectedAdvanceId(advanceId);
    setShowModal(true);
    fetchAdvancePaidLogs(advanceId);
  };

  // Close modal
  const closeModal = () => {
    setShowModal(false);
    setModalData([]);
    setSelectedAdvanceId(null);
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="table-responsive p-0 pb-2">
            <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0 datatable">
              <thead>
                <tr>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    S/N
                  </th>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    Name
                  </th>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    Total Amount
                  </th>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    Date
                  </th>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    Effective Month
                  </th>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    Effective Year
                  </th>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    Remarks
                  </th>
                  <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {Object.keys(props.data).map((item, index) => (
                  <tr key={item.id}>
                    <td className="text-xs">{index + 1}</td>
                    <td className="text-xs">{props.data[index]?.staff?.name}</td>
                    <td className="text-xs">{props.data[index]?.total_amount}</td>
                    <td className="text-xs">{props.data[index]?.date}</td>
                    <td className="text-xs">{getMonthName(props.data[index]?.effective_month)}</td>
                    <td className="text-xs">{props.data[index]?.effective_year}</td>
                    <td className="text-xs">{props.data[index]?.remarks}</td>
                    <td className="text-xs">
                      <button
                        className="btn btn-info btn-sm me-1"
                        onClick={() => handleDetailsClick(props.data[index].id)}
                        title="View Details"
                      >
                        <i className="fa fa-eye" aria-hidden="true"></i>
                      </button>
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* Details Modal */}
        {showModal && (
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Salary Advance Paid Logs</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  {modalLoading ? (
                    <div className="text-center">
                      <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      <p>Loading paid logs...</p>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-striped table-bordered">
                        <thead>
                          <tr>
                            <th>S/N</th>
                            <th>Original Amount</th>
                            <th>Installment Amount</th>
                            <th>Installment Number</th>
                            <th>Total Installments</th>
                            <th>Deduction Month</th>
                            <th>Deduction Year</th>
                            <th>Remaining Balance</th>
                            <th>Remarks</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {modalData.length > 0 ? (
                            modalData.map((log, index) => (
                              <tr key={log.id}>
                                <td>{index + 1}</td>
                                <td>{log.original_amount}</td>
                                <td>{log.installment_amount}</td>
                                <td>{log.installment_number}</td>
                                <td>{log.total_installments}</td>
                                <td>{log.deduction_month}</td>
                                <td>{log.deduction_year}</td>
                                <td>{log.remaining_balance}</td>
                                <td>{log.remarks}</td>
                                <td>
                                  <span className={`badge ${log.status === 'active' ? 'badge-success' : 'badge-secondary'}`}>
                                    {log.status}
                                  </span>
                                </td>
                                
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="11" className="text-center">
                                No paid logs found for this salary advance
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const actionTemplate = (item, deleteData, handleDetailsClick) => {
  return (
    <td className="text-xs">
      <button
        className="btn btn-info btn-sm me-1"
        onClick={() => handleDetailsClick(item.id)}
        title="View Details"
      >
        <i className="fa fa-eye" aria-hidden="true"></i>
      </button>
      <Link
        to={{
          pathname: "/edit-salary-advance/" + item.id,
        }}
        className="btn btn-primary btn-sm me-1"
      >
        <i className="fa fa-pencil" aria-hidden="true"></i>
      </Link>
      <button
        className="btn btn-danger btn-sm"
        onClick={() => deleteData(item.id, "transaction", "Salary Advance")}
      >
        <i className="fa fa-trash"></i>
      </button>
    </td>
  );
};

export default SalaryAdvance;
